import { Pipe, PipeTransform } from '@angular/core';
import { differenceWith } from 'lodash';

@Pipe({
  name: 'excludeInclude'
})
export class ExcludeIncludePipe implements PipeTransform {

  transform(items: Array<any>, filter: Array<any> = [], action:string): any {
    if(!(items)) {
      return;
    }
    if(action == "EXCLUDE"){
    return differenceWith(items, filter, ((c,c2) => c.code == c2.code));
    }
    return filter;
  }

}
